/** Icon column (48) plus 9px insets on each side. */
export const RAIL_SIDEBAR_WIDTH = 66;
/** Native landscape navigation strip: a 44pt button between 9pt gutters. */
export const PRIMARY_NAVIGATION_RAIL_WIDTH = 62;
export const PERMANENT_SIDEBAR_WIDTH = 280;
export const OVERLAY_SIDEBAR_WIDTH = "70%";
